import { render, staticRenderFns } from "./attribute-value.vue?vue&type=template&id=20e9fc48&"
import script from "./attribute-value.vue?vue&type=script&lang=js&"
export * from "./attribute-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports